module.exports = new __parcel__URL__("level_7_tab_active.9abe64c6.png").toString();